export const PERSEUS_NAME = 'freelancer_page_perseus';
export const METRICS_PREFIX = `services.${PERSEUS_NAME}`;

export { Routes, BASE_NAME } from './routes';

export const TRIGGER_RELEASE_TAG = true; // TODO: remove this
